<template>
  <main class="home-page">
    <section v-if="!isAuthenticated" class="guest-hero">
      <div class="guest-hero__badge">Контент-платформа</div>
      <h1 class="guest-hero__title">Для работы с потоками и публикациями нужна авторизация</h1>
      <p class="guest-hero__text">
        Войдите в аккаунт, чтобы управлять стримами, генерировать контент и смотреть статистику по использованию.
      </p>
      <div class="guest-hero__actions">
        <router-link class="btn btn-primary px-4" to="/login">Войти</router-link>
        <router-link class="btn btn-outline-primary px-4" to="/register">Создать аккаунт</router-link>
      </div>
      <div class="guest-hero__hint">Если аккаунт уже есть, используйте форму входа и восстановление пароля при необходимости.</div>
    </section>

    <section v-else class="user-panel">
      <h1 class="user-panel__title">Добро пожаловать, {{ currentUser?.username || 'пользователь' }}.</h1>
      <p class="user-panel__text">
        Откройте разделы слева: там доступны дашборд, стримы, профиль и инструменты публикации.
      </p>
      <div class="user-panel__actions">
        <router-link class="btn btn-primary btn-sm px-3" to="/dashboard">Перейти в дашборд</router-link>
        <router-link class="btn btn-outline-primary btn-sm px-3" to="/streams">Открыть стримы</router-link>
      </div>
    </section>
  </main>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'HomePage',
  setup() {
    const store = useStore()
    const isAuthenticated = computed(() => store.getters.isAuthenticated)
    const currentUser = computed(() => store.getters.currentUser)

    return { isAuthenticated, currentUser }
  },
}
</script>

<style scoped>
.home-page {
  min-height: calc(100vh - 70px);
  padding: 28px 22px;
  background:
    radial-gradient(circle at 12% 18%, rgba(13, 110, 253, 0.1), transparent 35%),
    radial-gradient(circle at 86% 82%, rgba(25, 135, 84, 0.08), transparent 42%),
    #f7f9fd;
}

.guest-hero {
  max-width: 860px;
  margin: 24px auto 0;
  padding: 30px 32px;
  border-radius: 18px;
  border: 1px solid #e6ebf6;
  background: #fff;
  box-shadow: 0 20px 38px rgba(17, 24, 39, 0.1);
}

.guest-hero__badge {
  display: inline-block;
  margin-bottom: 14px;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #2c61d6;
  background: #ecf3ff;
}

.guest-hero__title {
  margin: 0;
  font-size: clamp(24px, 3.2vw, 34px);
  line-height: 1.2;
  color: #19253f;
}

.guest-hero__text {
  margin: 14px 0 0;
  max-width: 680px;
  font-size: 16px;
  line-height: 1.55;
  color: #4b5a78;
}

.guest-hero__actions {
  margin-top: 22px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.guest-hero__hint {
  margin-top: 16px;
  font-size: 13px;
  color: #6a7793;
}

.user-panel {
  max-width: 780px;
  margin: 24px auto 0;
  padding: 24px 26px;
  border-radius: 14px;
  border: 1px solid #e6ebf6;
  background: #fff;
  box-shadow: 0 12px 30px rgba(17, 24, 39, 0.08);
}

.user-panel__title {
  margin: 0;
  font-size: 26px;
  color: #19253f;
}

.user-panel__text {
  margin: 10px 0 0;
  color: #506082;
  line-height: 1.45;
}

.user-panel__actions {
  margin-top: 16px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .home-page {
    padding: 18px 12px;
  }

  .guest-hero,
  .user-panel {
    margin-top: 8px;
    padding: 22px 18px;
  }
}
</style>
